import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import React, { useEffect, useState } from "react";
import useTrait from "../Common/syncUpdateState";

const center = {
  lat: 25.2744,
  lng: 133.7751,
};

const positionForAu = {
  lat: -25.0,
  lng: 135.0,
};

const positionFoNz = {
  lat: -40.9006,
  lng: 174.886,
};

const inputStyle = {
  boxSizing: `border-box`,
  border: `1px solid transparent`,
  width: `240px`,
  height: `32px`,
  padding: `0 12px`,
  borderRadius: `3px`,
  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
  fontSize: `14px`,
  outline: `none`,
  textOverflow: `ellipses`,
  position: "absolute",
  top: "10px",
  right: "10px",
};

const onLoad = (marker) => {
  //console.log("marker: ", marker);
};

const mapContainerStyle = {
  margin: "0 0",
  height: "400px",
  width: "full",
};

function RycoStoresMap({
  allMapStores,
  activeId,
  selectedLocation,
  selectSource,
}) {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  var selectLocAU = useTrait(
    allMapStores.length <= 0
      ? positionForAu
      : { lat: selectedLocation?.get()?.lat, lng: selectedLocation?.get()?.lon }
  );
  var selectedLocNZ = useTrait(
    allMapStores.length <= 0
      ? positionFoNz
      : { lat: selectedLocation?.get()?.lat, lng: selectedLocation?.get()?.lon }
  );
  var mapCenter = isAU ? selectLocAU.get() : selectedLocNZ.get();
  if (selectSource) mapCenter = selectSource;
  var [mapZoom, setMapZoom] = useState(selectSource ? 16 : 4);
  const [activeMarker, setActiveMarker] = useState(null);

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(12);
  }, []);
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  useEffect(() => {
    if (allMapStores.length > 0)
      panTo(
        typeof selectedLocation !== "undefined"
          ? {
              lat: selectedLocation?.get()?.lat,
              lng: selectedLocation?.get()?.lon,
            }
          : mapCenter
      );
  }, [allMapStores, selectedLocation, panTo, mapCenter, selectSource]);

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={mapZoom}
        center={mapCenter}
        onLoad={onMapLoad}
      >
        {allMapStores?.map(({ id, flatData, data }) => (
          <Marker
            key={id}
            position={{
              lat: flatData?.location.latitude,
              lng: flatData?.location.longitude,
            }}
            onClick={() => handleActiveMarker(id)}
          >
            {activeMarker === id ? (
              <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                <div>
                  {flatData?.title.trim() + ", " + flatData?.suburb.trim()}
                </div>
              </InfoWindow>
            ) : null}
          </Marker>
        ))}
      </GoogleMap>
    </div>
  );
}

export default RycoStoresMap;
